module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes,
    style: (_vm.styles),
    on: {
      "click": _vm.$_onDivClick
    }
  }, [_vm._t("default", [_c('i', {
    class: ((_vm.$constants.CLASS_MAIN) + " " + (_vm.$constants.PREFIX_ICON_CLASS) + "3x " + (_vm.$constants.PREFIX_ICON_CLASS) + "arrow-up-bold-circle icon-gradient-primary")
  })])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ddf141ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/back2top/back2top.vue
// module id = 413
// module chunks = 0